import jwtConfig from '@core/auth/jwt/jwtDefaultConfig'
import { readStoredUser, readStoredValue } from './session'

export const isUserLoggedIn = () => {
  const token = readStoredValue(jwtConfig.storageTokenKeyName)
  return Boolean(readStoredUser() && typeof token === 'string' && token.trim())
}

export const getUserData = readStoredUser

export const getHomeRouteForLoggedInUser = userRole => {
  if (Array.isArray(userRole) && userRole.length > 1
    && userRole.every(role => typeof role === 'string' && role.trim())) return '/'
  return { name: 'auth-login' }
}
